<template>
  <v-card class="planning input-card">
    <template>
      <v-row justify="center">
        <v-dialog v-model="showDialog" persistent max-width="500">
          <v-card>
            <v-card-title v-bind:style="{ backgroundColor: '#1e345d', color: 'white'}">
              <span class="headline">Add Checklist Item</span>
              <v-spacer></v-spacer>
              <v-btn color="white" icon @click="showDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-layout row wrap disabled="true">
                  <v-flex xs12>
                    <v-text-field label="Label" v-model="checklistObject.label"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select label="Type" :items="typeList" v-model="checklistObject.type"></v-select>
                  </v-flex>
                  <v-flex xs2 style="max-height:74px">
                    <p style="marginTop:25px; font-size:16px">Required</p>
                  </v-flex>
                  <v-flex xs9></v-flex>
                  <v-flex xs1>
                    <v-checkbox color="#2196f3" id="required" v-model="checklistObject.required"></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-alert v-if="this.error !=null" color="error" dark>
                <v-icon size="20" dark>warning</v-icon>
                {{this.error}}
              </v-alert>
            </v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="accent" depressed block @click="saveItem(checklistObject)">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <div class="tab-bar">
      <v-tabs v-model="tab"
              grow
              show-arrows>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#checklist">Checklist</v-tab>
        <v-tab v-if="this.userRole != 'Sub Foreman'" href="#crews">Schedule</v-tab>
        <v-tab href="#images">Pre Job Images</v-tab>
        <v-tab href="#documents">Documents</v-tab>
        <v-tab v-if="this.userRole === 'Admin'" href="#changeOrders">Change Orders</v-tab>
      </v-tabs>
    </div>
    <v-tabs-items v-model="tab">
      <v-tab-item value="checklist">
        <v-container class="input-wrapper" pa-0>
          <v-row>
            <v-col>
              <div  v-if="selectedChecklist && selectedChecklist.checklistObject.length > 0">
              <v-simple-table>
                <template v-slot:default>
                  <tbody v-for="checklistItem in selectedChecklist.checklistObject" :key="checklistItem.label">
                    <planning-checklist :updateSaved="checklistSaved" :checklistItem="checklistItem" :checklistId="selectedChecklist.id"></planning-checklist>
                    <div></div>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td class="text-right" colspan="12">
                        <div style="margin-top: 5px;">
                                                   
                          <v-tooltip bottom color="secondary">
                            <template v-slot:activator="{ on }">
                              <v-btn small icon color="accent" :disabled="!isSaved" :to="{name: 'PrintableChecklist'}" class="btn-save" style="margin-left: 4px;">
                                <v-icon size="32">mdi-printer</v-icon>
                              </v-btn>
                            </template>
                            <span>Open a printable checklist page</span>
                          </v-tooltip>

                          <v-tooltip bottom color="secondary">
                            <template v-slot:activator="{ on }">
                              <v-btn icon large color="accent" v-on="on" @click="toggleAddItem" style="margin-right: 15px;"><v-icon>mdi-plus</v-icon></v-btn>
                            </template>
                            <span>Add checklist item</span>
                          </v-tooltip>

                          <v-tooltip bottom color="secondary">
                            <template v-slot:activator="{ on }">
                              <v-btn outlined color="accent" @click="clickSave" class="btn-save" v-on="on">
                                Save
                              </v-btn>
                            </template>
                            <span>Save checklist</span>
                          </v-tooltip>

                        </div>
                      </td>
                    </tr>
                  </tfoot>
                </template>
              </v-simple-table>
              </div>
              <div v-else>
                <v-col style="text-align: center;">Loading....</v-col>
                <v-progress-linear
                                   indeterminate
                                   absolute
                                   height="6"
                                   background-opacity="0.3"
                                   color="accent"></v-progress-linear>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item value="changeOrders">
        <v-container class="input-wrapper">
          <v-row>
            <v-col class="spacing-col" cols="2"></v-col>
            <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12">
              <file-upload uploadType="change" ref="saveChange" step="Planning"></file-upload>
            </v-col>
            <v-col class="spacing-col" cols="2"></v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item value="images">
        <v-container class="input-wrapper">
          <v-row>
            <v-col class="spacing-col" cols="2"></v-col>
            <v-col class="document-uploader-wrapper" xs="12" sm="12" md="8" lg="8" xl="8" cols="12">
              <file-upload uploadType="image" ref="saveImages" imageType="Pre Job Image"></file-upload>
            </v-col>
            <v-col class="spacing-col" cols="2"></v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item value="documents">
        <v-container class="input-wrapper">
          <v-row>
            <v-col class="spacing-col" cols="2"></v-col>
            <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12">
              <file-upload uploadType="document" ref="saveDocs" step="Planning"></file-upload>
            </v-col>
            <v-col class="spacing-col" cols="2"></v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item value="crews">
        <v-container class="input-wrapper">
          <template>
            <v-row justify="center">
              <v-dialog v-model="showAddDialog" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline pt-1 pr-1" v-bind:style="{ backgroundColor: '#1e345d', color: 'white'}">
                    Add Crew To Task
                    <v-spacer></v-spacer>
                    <v-btn icon @click="showAddDialog = false">
                      <v-icon color='white'>close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-container>
                    <v-select label="Crew Name / Number"
                              :items="crews"
                              v-model="crewSelected"
                              chips
                              hide-no-data
                              clearable
                              item-text="text"
                              item-value="value">
                    </v-select>
                  </v-container>
                  <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn outlined color="accent" @click="addCrewToTask">Add</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <v-row>
            <v-col cols="1"></v-col>
            <v-col cols="10">
              <v-layout row wrap style="padding:12px">
                <v-flex lg4 sm12 xs12 style="height:75px">
                  <v-dialog ref="startDialog"
                            :return-value.sync="startDate"
                            persistent
                            width="290px"
                            v-model="startDateModal">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="selectedTask.startDate"
                                    label="Start Date"
                                    readonly
                                    :rules="[checkDates() || 'Start date is invalid, must fall before end date or any scheduled days']"
                                    v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="startDate" type="date" @input="$refs.startDialog.save(selectedTask.startDate)" scrollable>
                      <div class="flex-grow-1"></div>
                      <v-btn text color="accent" @click="startDateModal = false">Cancel</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex lg4 sm12 xs12 style="height:75px">
                  <v-dialog ref="endDialog"
                            :return-value.sync="completionDate"
                            persistent
                            width="290px"
                            v-model="endDateModal">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="selectedTask.completionDate"
                                    label="End Date"
                                     :rules="[checkDates() || 'End date is invalid, must be greater then start date or any scheduled days']"
                                    readonly
                                    v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="completionDate" type="date" @input="$refs.endDialog.save(selectedTask.completionDate)" scrollable>
                      <div class="flex-grow-1"></div>
                      <v-btn text color="accent" @click="endDateModal = false">Cancel</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex lg4 sm12 xs12 style="height:75px">
                  <v-dialog ref="isdDialog"
                            :return-value.sync="isd"
                            persistent
                            width="290px"
                            v-model="isdDateModal">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="selectedTask.isd"
                                    label="ISD"
                                    readonly
                                    v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="isd" type="date" @input="$refs.isdDialog.save(selectedTask.isd)" scrollable>
                      <div class="flex-grow-1"></div>
                      <v-btn text color="accent" @click="isdDateModal = false">Cancel</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-col>
            <v-flex cols="1"></v-flex>
          </v-row>
          <v-row>
            <v-col cols="1"></v-col>
            <v-col cols="10">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left crew-name-header">Crew Name / Number</th>
                      <th class="text-left crew-lead-name-header">Lead Name</th>
                      <th class="text-left crew-lead-phone-header">Lead Phone</th>
                      <th class="text-left crew-lead-email-header">Lead Email</th>
                      <th class="text-left">Actions</th>
                    </tr>
                  </thead>
                  <tbody v-for="crew in crewSelected" :key="crew.name">
                    <checklist-crew-details :crew="crew.value"
                                            ref="crew"
                                            :selectedCrews="crewSelected">
                    </checklist-crew-details>
                    <div></div>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td class="text-right" colspan="6">
                        <div>
                          <v-btn @click="showAddDialog = true" medium color="accent">Add Crew</v-btn>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="1">
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1"></v-col>
            <v-col>
              <schedule-day></schedule-day>
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
    <div v-if="this.userRole !== 'Sub Foreman'" class="footer">
      <v-container pa-0>
        <v-row>
          <v-col class="spacing-col" cols="2"></v-col>
          <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12" class="btn-wrapper">
            <div v-if="!this.showReset">
            <v-tooltip bottom color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn depressed :disabled="disabled" color="accent" class="btn-complete" @click="complete" v-on="on">
                  Complete
                  <v-icon dark right>mdi-checkbox-marked-circle</v-icon>
                </v-btn>
              </template>
              <span>Move to next step (Execution)</span>
            </v-tooltip>
            </div>

            <div v-if="showReset">
            <v-tooltip bottom color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn depressed color="accent" class="btn-reset" @click="reset" v-on="on">
                  Reset
                  <v-icon dark right>mdi-history</v-icon>
                </v-btn>
              </template>
              <span>Reset to this step (Planning)</span>
            </v-tooltip>
            </div>

          </v-col>
          <v-col class="spacing-col" cols="2"></v-col>
        </v-row>
      </v-container>
      <v-snackbar v-model="showMessage" :color="taskStatus">
        {{ message }}
        <v-btn icon color="white" text @click="showMessage = false">
          <v-icon size="28">mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
    </div>
  </v-card>
</template>
<script>

import { mapGetters, mapActions } from 'vuex'
import PlanningChecklist from '@/components/checklists/PlanningChecklist'
import FileUpload from '@/components/files/FileUpload'
import ChecklistCrewDetails from '@/components/workorders/taskManagerTabs/PlanningCrewDetails'
import ScheduleDay from '@/components/scheduling/ScheduleDay'
export default {
  name: 'Planning',
  components: {
    PlanningChecklist,
    FileUpload,
    ChecklistCrewDetails,
    ScheduleDay
    },
    props: {
      checklistSaved: {
        type: Function,
        required: true
      },
      isSaved: {
        type: Boolean,
        required: true
      }
    },
    async created() {
    if (this.selectedTask !== null) {
      this.clearChecklist()
      await this.loadChecklist(this.selectedTask.id)
      this.selectedTask.startDate = this.selectedTask.startDate.slice(0, 10)
      this.selectedTask.completionDate = this.selectedTask.completionDate.slice(0, 10)
      this.selectedTask.isd = this.selectedTask.isd.slice(0, 10)
      this.loadScheduleDaysForTask(this.selectedTask.id)
    } else {
      this.clearSchedule
    }   
    },
  watch: {
    'selectedTask.startDate': function (value) {
      this.selectedTask.startDate = this.selectedTask.startDate.slice(0, 10)
    },
    'selectedTask.completionDate': function (value) {
      this.selectedTask.completionDate = this.selectedTask.completionDate.slice(0, 10)
    },
    'selectedTask.isd': function (value) {
      this.selectedTask.isd = this.selectedTask.isd.slice(0, 10)
    },
  },
  data: () => ({
    tab: 'checklist',
    showMessage: false,
    startDateModal: false,
    endDateModal: false,
    isdDateModal: false,
    showAddDialog: false,
    message: '',
    crewSelectedGetter: {},
    crewToAdd: {
      crewId: null,
      taskId: null
    },
    requiredItems: [],
    crewsOnTask: null,
    taskStatus: 'info',
    showDialog: false,
    typeList: ['other', 'number', 'date'],
    boolList: ['true', 'false'],
    error: null,
    checklistObject: {
      label: null,
      type: null,
      required: null,
      info: '',
      notes: '',
      yesChecked: false,
      noChecked: false,
      naChecked: false,
      checkedBy: ''
    },
    saved: true
  }),
  methods: {
    ...mapActions({
      updateChecklist: 'checklist/updateChecklist',
      loadChecklist: 'checklist/loadChecklistByTask',
      clearChecklist: 'checklist/clearingChecklist',
      removeCrew: 'workOrderTask/removeCrew',
      addCrew: 'workOrderTask/addCrew',
      update: 'workOrderTask/updateTask',
      loadScheduleDaysForTask: 'schedule/loadSchedule',
      clearSchedule: 'schedule/clearSchedule',
      createDay: 'schedule/createScheduledDay'
    }),
    addCrewToTask () {
      if (this.crewToAdd.crewId !== null && this.crewToAdd.taskId !== null) {
        this.addCrew(this.crewToAdd)
        this.showAddDialog = false
        this.display('Crew Added')
      } else {
        this.display('Failed to Add Crew')
      }
    },
    clickSave() {
      let res = this.updateChecklist(this.selectedChecklist)
      if (res) {        
        this.checklistSaved(true)
        this.display('Checklist Saved')
      }
    },
    saveItem () {
      this.selectedChecklist.checklistObject.push(this.checklistObject)
      let res = this.updateChecklist(this.selectedChecklist)
      this.showDialog = false
      if (res) {
       this.checklistSaved(true)
        return true
      }
    },
    toggleAddItem () {
      this.showDialog = !(this.showDialog)
    },

    display (message) {
      this.message = message
      if (message === 'Checklist Saved' || message === 'Task OK' || message === 'Crew Added') {
        this.taskStatus = 'success'
      } else {
        this.taskStatus = 'error'
      }
      this.showMessage = true
    },
    complete () {
      let updateStatus = this.selectedTask
      updateStatus.status = 'Execution'
      delete updateStatus.workOrder
      this.update(updateStatus)
    },
    reset () {
      let updateStatus = this.selectedTask
      updateStatus.status = 'Planning'
      delete updateStatus.workOrder
      this.update(updateStatus)
    },
    checkDates() {
      let valid = true

      let endDate = new Date(this.selectedTask.completionDate.slice(0, 10))
      let startDate = new Date(this.selectedTask.startDate.slice(0, 10))

          this.schedule.forEach(d => {
            let day = new Date(d.start.slice(0, 10))

            if (startDate > day) { valid = false }
            if (endDate < day) { valid =  false}
          })

      if (startDate > endDate) { valid = false }

      return valid
    },
    async addScheduleDay() {
      if (this.schedule.length === 0) {
        if (this.selectedTask.startDate !== null && this.selectedTask.completionDate !== null) {
          let schedule = {}
          if (this.selectedTask.startDate.slice(0, 10) === this.selectedTask.completionDate.slice(0, 10)) {            
            schedule = {
              note: null,
              crewId: null,
              start: this.selectedTask.startDate.slice(0,10)+ 'T' + this.getDefaultTimes.start,
              end: this.selectedTask.startDate.slice(0, 10) + 'T' + this.getDefaultTimes.end,
              workOrderTaskId: this.selectedTask.id
            }
          } else {
            schedule = {
              note: null,
              crewId: null,
              start: this.selectedTask.startDate.slice(0,10)+ 'T' + this.getDefaultTimes.none,
              end: this.selectedTask.completionDate.slice(0, 10) + 'T' + this.getDefaultTimes.none,
              workOrderTaskId: this.selectedTask.id
            }
          }
          await this.createDay(schedule)
        }
      }
    },
    async updateTask() {
      if (this.checkDates()) {
        await this.update(this.selectedTask)
        if (this.errorTask === null) {
          await this.addScheduleDay()
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedChecklist: 'checklist/selectedChecklist',
      selectedTask: 'workOrderTask/selectedTask',
      changeOrders: 'changeOrder/changeOrdersByTask',
      crews: 'crew/crewsForTasks',
      selectedCrew: 'workOrderTask/selectedCrewTask',
      userRole: 'user/role',
      step: 'workOrderTask/step',
      schedule: 'schedule/scheduleByTask',
      errorTask: 'workOrderTask/error',
      getDefaultTimes: 'schedule/getDefaultTimes'
    }),

    disabled () {
      let tempArray = []
      let count = 0
      if (this.selectedChecklist && this.selectedChecklist.checklistObject.length > 0) {
        for (let i = 0; i < this.selectedChecklist.checklistObject.length; i++) {
          if (this.selectedChecklist.checklistObject[i].required === true) {
            count++
            if (this.selectedChecklist.checklistObject[i].yesChecked === true || this.selectedChecklist.checklistObject[i].noChecked === true || this.selectedChecklist.checklistObject[i].naChecked) {
              tempArray.push(this.selectedChecklist.checklistObject[i])
            }
          }
        }
      }
      if (tempArray.length === count && this.isSaved) {
        return false
      } else {
        return true
      }
    },
    showReset () {
      if (this.step > 2) {
        return true
      } else {
        return false
      }
    },
    isd: {
      get () {
        if (this.selectedTask.isd.slice(0, 10) === '0001-01-01') {
          var date = new Date()
          var month = '' + (date.getMonth() + 1)
          var day = '' + date.getDate()
          var year = date.getFullYear()

          if (month.length < 2) { month = '0' + month }
          if (day.length < 2) { day = '0' + day }

          var datestring = year + '-' + month + '-' + day
          return datestring
        } else {
          return this.selectedTask.isd.slice(0, 10)
        }
      },
      set (value) {
        if (this.selectedTask.isd !== value) {
           this.selectedTask.isd = value
           this.updateTask()
        }
      }
    },
    completionDate: {
      get () {
        if (this.selectedTask.completionDate.slice(0, 10) === '0001-01-01') {
          var date = new Date()
          var month = '' + (date.getMonth() + 1)
          var day = '' + date.getDate()
          var year = date.getFullYear()

          if (month.length < 2) { month = '0' + month }
          if (day.length < 2) { day = '0' + day }

          var datestring = year + '-' + month + '-' + day
          return datestring
        } else {
          return this.selectedTask.completionDate.slice(0, 10)
        }
      },
      set(value) {
        if (this.selectedTask.completionDate !== value) {
            this.selectedTask.completionDate = value
            this.updateTask()
        }


      }
    },
    startDate: {
      get () {
        if (this.selectedTask.startDate.slice(0, 10) === '0001-01-01') {
          var date = new Date()
          var month = '' + (date.getMonth() + 1)
          var day = '' + date.getDate()
          var year = date.getFullYear()

          if (month.length < 2) { month = '0' + month }
          if (day.length < 2) { day = '0' + day }

          var datestring = year + '-' + month + '-' + day
          return datestring
        } else {
          return this.selectedTask.startDate.slice(0, 10)
        }
      },
      set (value) {
        if (this.selectedTask.startDate !== value) {
           this.selectedTask.startDate = value
           this.updateTask()
        }
      }
    },
    crewSelected: {
      get () {
        if (this.selectedTask != null) {
          return this.selectedCrew.map(c => {
            return {
              text: (`${this.selectedTask.region.name}-${c.crew.name}-${c.crew.crewLead.firstName}`),
              value: c.crew
            }
          })
        } else {
          return null
        }
      },
      set (crew) {
        if (this.selectedTask != null) {
          this.crewToAdd.crewId = crew.id
          this.crewToAdd.taskId = this.selectedTask.id
        }
      }
    }
  }
}
</script>
<style scoped>
  ::placeholder {
    color: rgba(0, 0, 0, 0.87) !important;
  }
  .input-card {
    border: 1px solid #e0e0e0 !important;
    border-radius: 0;
  }
  .input-wrapper {
    min-height: 280px;
    padding: 0;
  }
  .tab-bar {
    border-bottom: 1px solid #e0e0e0 !important;
  }
  .btn-wrapper {
    padding: 0 12px 16px 0 !important;
    margin-bottom: 16px;
  }
  .btn-reset,
  .btn-save,
  .btn-complete {
    float: right;
  }
  .btn-complete {
    color: #fff;
    margin: 0 0 0 16px;
  }
  .btn-reset {
    margin-left: 16px;
  }
  @media only screen and (max-width: 959px) {
    .input-wrapper {
      padding: 0 16px;
    }
    .btn-wrapper {
      padding-right: 28px !important;
    }
    .spacing-col {
      display: none;
    }
  }
  @media only screen and (max-width: 550px) {
    .document-uploader-wrapper {
      padding-bottom: 20px;
    }
  }
  @media only screen and (max-width: 420px) {
    .input-card {
      border-left: none !important;
      border-right: none !important;
      border-radius: 0 !important;
    }
  }
  @media only screen and (max-width: 720px) {
    .crew-lead-phone-header,
    .crew-lead-email-header {
      display: none;
    }
    .crew-name-header {
      padding-left: 0;
    }
  }
</style>
